/**
 * Избранные лекарства — контракт ручек (`/me/favorites` в `openapi.yaml`,
 * пока только на staging); бэкенд сделан по docs/notes/favorites-contract.md.
 *
 *   GET    /api/v1/me/favorites                 — { items: [{ product_id, added_at }] }, новые сверху
 *   PUT    /api/v1/me/favorites/{product_id}    — добавить (повтор — не ошибка)
 *   DELETE /api/v1/me/favorites/{product_id}    — убрать (нет — не ошибка)
 *   POST   /api/v1/me/favorites/merge           — { product_ids } гостя после входа
 *
 * Карточки товаров приложение берёт из каталога одним запросом
 * (`GET /catalog/products?ids=1,2,3`): цена и наличие там всегда свежие.
 */

export interface FavoriteDto {
  product_id: number
  added_at: string
}

/** Сколько избранного держим: больше — уже не «избранное», а каталог. */
export const FAVORITES_MAX = 200
